import { get, post, put, deleted } from '..';
import routes from './routes';

const ReportServices = {
  // Execute dynamic search
  executeSearch: async (entity, criteria) => {
    const data = await post(`search/${entity}/execute`, criteria);
    return data;
  },

  // Save search/report
  saveSearch: async (entity, name, criteria, isPublic, isReport) => {
    const data = await post(`search/${entity}/save`, {
      name,
      criteria,
      isPublic,
      isReport
    });
    return data;
  },

  // Get saved searches
  getSavedSearches: async (entity, params = {}) => {
    const data = await get(`search/${entity}/saved`, params);
    return data;
  },

  // Get saved search by ID
  getSavedSearch: async (entity, id) => {
    const data = await get(`search/${entity}/saved/${id}`);
    return data;
  },

  // Update saved search
  updateSavedSearch: async (entity, id, updateData) => {
    const data = await put(`search/${entity}/saved/${id}`, updateData);
    return data;
  },

  // Delete saved search
  deleteSavedSearch: async (entity, id) => {
    const data = await deleted(`search/${entity}/saved/${id}`);
    return data;
  },

  // Get entity metadata
  getEntityMetadata: async (entity) => {
    const data = await get(`search/${entity}/metadata`);
    return data;
  },

  // Execute saved search
  executeSavedSearch: async (entity, savedSearchId, params = {}) => {
    const data = await get(`search/${entity}/execute/${savedSearchId}`, params);
    return data;
  },

  // Get reports list
  getReports: async () => {
    const data = await get(routes.getReports);
    return data;
  },

  // Legacy methods (keeping for compatibility)
  getReports: async (params) => {
    const data = await get(routes.getReports, params);
    return data;
  },
  createRefundExchange: async (payload) => {
    const data = await post(routes.getRefundExchange, payload);
    return data;
  },
  calculateRefundExchange: async (payload) => {
    const data = await post(routes.calculateRefundExchange, payload);
    return data;
  },
  getRefund: async (id) => {
    const data = await get(`${routes.getRefund}/${id}`);
    return data;
  },
  getExchange: async (id) => {
    const data = await get(`${routes.getExchange}/${id}`);
    return data;
  },
  generateExchangeReceipt: async (exchangeId) => {
    const data = await get(routes.generateExchangeReceipt.replace(':id', exchangeId));
    return data;
  },
  generateRefundReceipt: async (refundId) => {
    const data = await get(routes.generateRefundReceipt.replace(':id', refundId));
    return data;
  },
};

export default ReportServices;